import cls from 'classnames';
import { Children, useCallback, useEffect, useState } from 'react';

import Bullet from './Bullet';
import useStyles from './styles';
import ICarousel from './types';

const calculateTranslate = (index: number, padding: number, extraPadding: number) => {
  const percent = `${-(index * 100)}%`;
  const pad = `${index * (padding + extraPadding)}px`;

  return index > 0 ? `translate(calc(${percent} - ${pad}))` : 'none';
};

let timeout: ReturnType<typeof setTimeout>;

function GenericCarousel({
  children,
  className,
  header,
  padding = 40,
  loop,
  loopInterval = 5000,
  hasBullets = true,
  bulletColor = 'magenta',
  extraPadding = 0,
  ...rest
}: ICarousel) {
  const classes = useStyles({ padding });
  const frames = Children.toArray(children);
  const [currentIndex, setCurrentIndex] = useState(0);
  const changeIndex = useCallback(() => {
    setCurrentIndex(currentIndex === frames.length - 1 ? 0 : currentIndex + 1);
  }, [currentIndex, frames]);

  useEffect(() => {
    if (loop) {
      timeout = setTimeout(changeIndex, loopInterval);
    }
  }, [currentIndex]);

  return (
    <section className={cls(className, classes.root)} {...rest}>
      {header}
      <div
        className={classes.itemContainer}
        style={{ transform: calculateTranslate(currentIndex, padding, extraPadding) }}
      >
        {frames.map((frame, index) => (
          <div className={classes.item} key={`f-${index}`}>
            {frame}
          </div>
        ))}
      </div>

      {hasBullets && (
        <ul className={classes.bullets}>
          {Array(frames.length)
            .fill(undefined)
            .map((_, i) => {
              const isActive = i === currentIndex;

              return (
                <li key={`b-${i}`}>
                  <Bullet
                    color={bulletColor}
                    onClick={() => {
                      setCurrentIndex(i);
                      clearTimeout(timeout);
                    }}
                    isActive={isActive}
                  />
                </li>
              );
            })}
        </ul>
      )}
    </section>
  );
}

export default GenericCarousel;
